import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import StatusTag from "../../../../components/StatusTag";
import { ColDataProps } from "../../LandingPage";

const noSiteData =
  "There is currently no site selection data available for this study.";
const noCountryData =
  "There is currently no country validation data available for this study.";
const noPreCountryData =
  "There is currently no preliminary country validation data available for this study.";

interface DesignModuleProps {
  type: "country" | "site" | "pre-country";
  title: string;
  status?: string;
  total: number;
  viewLink: string;
  viewButtonText: string;
  progress?: number;
  datasource?: ColDataProps[];
  opt?: string;
  disableProgress?: boolean;
}
const DesignModule: React.FC<DesignModuleProps> = ({
  type,
  title,
  status,
  total,
  viewLink,
  viewButtonText,
  progress,
  datasource,
  opt,
  disableProgress,
}) => {
  const percentage =
    progress && total === 0 ? Math.round((progress / total) * 100) : 0;

  return (
    <Module>
      <TitleRow>
        <span className="module-title">
          <i className="title-text">{title}</i>
        </span>
        {total === 0 && !disableProgress ? (
          <span className="progress">Progress: {percentage}% Completed</span>
        ) : null}
      </TitleRow>
      <Board>
        {!total ? (
          <div className="no-data-tip">
            {type === "country" && noCountryData}
            {type === "site" && noSiteData}
            {type === "pre-country" && noPreCountryData}
          </div>
        ) : (
          <>
            <Status>
              <p>
                <StatusTag status={status || ""} />
              </p>
              <span>{opt}</span>
            </Status>
            <NumberContainer>
              <div className="view">
                <Link to={viewLink}>{viewButtonText}</Link>
              </div>
              <Numbers>
                {datasource?.map((d: ColDataProps) => (
                  <div className="count" key={d.key}>
                    <p>{d.value}</p>
                    <span>{d.label}</span>
                  </div>
                ))}
              </Numbers>
            </NumberContainer>
          </>
        )}
      </Board>
    </Module>
  );
};
const Module = styled("div")({
  marginBottom: "5rem",
});
const TitleRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-end",
  paddingBottom: "10px",
  marginBottom: "25px",
  borderBottom: "1px solid #D5D2CA",
  "& .module-title": {
    color: "#000000",
    fontSize: "1.25rem",
    display: "flex",
    alignItems: "flex-end",
  },
  "& .title-text": {
    fontStyle: "normal",
    paddingRight: "10px",
  },
  "& .progress": {
    color: "#666666",
    fontSize: "0.65rem",
  },
});
const Board = styled("div")({
  display: "flex",
  background: "#FAFAFA rgba(255, 255, 255, 0.05)",
  boxShadow:
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)",
  "& p": {
    marginBottom: "0.2rem",
    display: "flex",
    alignItems: "center",
    color: "#000000",
  },
  "& span": {
    color: "#82786F",
  },
  "& ": {
    flex: "1",
  },

  "& .status": {
    flex: "1",
    background: "#F5F5F5",
    padding: "0.75rem 1.375rem",
    "& p": {
      fontSize: "1.125rem",
    },
    "& span": {
      fontSize: "0.75",
    },
  },
  "& .no-data-tip": {
    minHeight: "100px",
    width: "100%",
    color: "#666666",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const Status = styled("div")({
  flex: "1",
  background: "#F5F5F5",
  padding: "0.75rem 1.375rem",
  "& p": {
    fontSize: "1.125rem",
  },
  "& span": {
    fontSize: "0.75",
  },
});

const NumberContainer = styled("div")({
  flex: "3",
  paddingBottom: "1rem",
  "& .view": {
    textAlign: "right",
    padding: "0.5rem",
    fontSize: "0.75rem",
    color: "#D52B1E",
    textDecoration: "underline",
  },
});
const Numbers = styled("div")({
  display: "flex",
  flex: "3",
  "& .count": {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRight: "1px solid #D5D2CA",
    "&:last-child": {
      borderRight: "1px solid transparent",
    },
    "& p": {
      fontSize: "2.375rem",
      height: "3.125rem",
    },
    "& span": {
      color: "color: rgba(0, 0, 0, 0.6)",
      textAlign: "center",
      fontSize: "0.625rem",
      fontWeight: "bold",
      padding: "0 0.625rem",
    },
  },
});

export default DesignModule;
